import CrudAPI from '@/api/resources/crud'

const schedulesAPI = {
  // specific schedules api
  resource: 'schedules',
  url_query: '/api/schedules',

  loadSchedule (id) {
    return new Promise((resolve, reject) => {
      let Schedule = CrudAPI.dfsResourceShow(this.resource, id)

      Schedule.then(result => {
        resolve(result)
      }, error => {
        reject(error)
      })
    })
  },

  loadSchedules () {
    return new Promise((resolve, reject) => {
      let schedules = CrudAPI.dfsResourceIndex(this.resource)

      schedules.then(result => {
        result.forEach((item, i) => {
          item.text = item.name
          item.value = item.id
        })

        resolve(result)
      }, error => {
        reject(error)
      })
    })
  },

  saveSchedule (payload) {
    return new Promise((resolve, reject) => {
      let schedules = CrudAPI.dfsResourceStore(this.resource, payload)

      schedules.then(result => {
        resolve(result)
      }, error => {
        reject(error)
      })
    })
  },

  updateLeadWithDates (leadUuid, startDate, endDate) {
    return new Promise((resolve, reject) => {
      let payload = {
        schedule_start: startDate,
        schedule_end: endDate
      }

      let schedules = CrudAPI.dfsResourceUpdate(this.resource + '/leads', leadUuid, payload, '/dates')

      schedules.then(result => {
        resolve(result)
      }, error => {
        reject(error)
      })
    })
  },

  updateLead (leadUuid, caseManagerId, palbearersIds, venueDescription) {
    return new Promise((resolve, reject) => {
      let payload = {
        case_manager_id: caseManagerId,
        palbearers_ids: palbearersIds,
        venue_description: venueDescription
      }

      let schedules = CrudAPI.dfsResourceUpdate(this.resource + '/leads', leadUuid, payload)

      schedules.then(result => {
        resolve(result)
      }, error => {
        reject(error)
      })
    })
  },

  updatePallbearers (leadUuid, palbearersIds, closing) {
    return new Promise((resolve, reject) => {
      let payload = {
        pallbearers_ids: palbearersIds,
        is_closing: closing === 1
      }

      let schedules = CrudAPI.dfsResourceUpdate(this.resource + '/pallbearers', leadUuid, payload)

      schedules.then(result => {
        resolve(result)
      }, error => {
        reject(error)
      })
    })
  },

  updateScheduleWithDates (id, itemId, startDate, endDate) {
    return new Promise((resolve, reject) => {
      let payload = {
        item_id: itemId,
        schedule_start: startDate,
        schedule_end: endDate
      }

      let schedules = CrudAPI.dfsResourceUpdate(this.resource, id, payload)

      schedules.then(result => {
        resolve(result)
      }, error => {
        reject(error)
      })
    })
  }
}

export default schedulesAPI



// WEBPACK FOOTER //
// ./src/api/resources/schedules.js